var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControlChart4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7890",
    "data-name": "Group 7890",
    transform: "translate(-1339 -224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5199",
    "data-name": "Rectangle 5199",
    transform: "translate(1339 224)",
    fill: "#fff",
    stroke: "#e4e4e4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_2388",
    "data-name": "Line 2388",
    x2: 16,
    transform: "translate(1339 232)",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 2,
    strokeDasharray: "3 2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlChart4);
export default __webpack_public_path__ + "static/media/ControlChart4.796bb05ea913af050704afcaeb1cdd31.svg";
export { ForwardRef as ReactComponent };